var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.98,
    height: 64.981,
    viewBox: "0 0 64.98 64.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48bfe3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.504 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.385,44.3A25.959,25.959,0,0,0,19.673,7.591a25.455,25.455,0,0,0-3.9,31.33,1.092,1.092,0,0,1-.15,1.3L2.374,53.466C-.262,56.1-.89,59.788,1.448,62.126l.4.4c2.338,2.338,6.024,1.711,8.66-.925L23.727,48.386a1.108,1.108,0,0,1,1.329-.178A25.454,25.454,0,0,0,56.385,44.3ZM24.466,39.51a19.181,19.181,0,1,1,27.126,0A19.2,19.2,0,0,1,24.466,39.51Z",
    transform: "translate(-0.001 0)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.108 12.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.353,78.49a2.067,2.067,0,0,1-2.061-2.061l-1.649-14.735a2.067,2.067,0,0,1,2.061-2.061h5.889a2.067,2.067,0,0,1,2.061,2.061l-1.649,14.735a2.067,2.067,0,0,1-2.061,2.061Z",
    transform: "translate(-160.643 -59.633)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.668,168.055a1.654,1.654,0,0,1-1.649,1.649h-2.5a1.654,1.654,0,0,1-1.649-1.649v-2.5a1.654,1.654,0,0,1,1.649-1.649h2.5a1.654,1.654,0,0,1,1.649,1.649Z",
    transform: "translate(-168.765 -142.419)",
    stroke: "#fff",
    strokeWidth: 1,
    fill: "url(#a)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchProblem);
export default __webpack_public_path__ + "static/media/search-problem.2a284f7ada806e942739921c61aa93c4.svg";
export { ForwardRef as ReactComponent };